import { render, staticRenderFns } from "./deleteStorehouseManage.vue?vue&type=template&id=fa4bccb4&scoped=true"
import script from "./deleteStorehouseManage.vue?vue&type=script&lang=js"
export * from "./deleteStorehouseManage.vue?vue&type=script&lang=js"
import style0 from "./deleteStorehouseManage.vue?vue&type=style&index=0&id=fa4bccb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4bccb4",
  null
  
)

export default component.exports